import React from "react";

const PrevArrowIcon = ({name, color, size}) => (
    <svg viewBox="0 0 19 32" className={`icon icon-${name}`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
        <path d="M18.526 3.212L15.813.5.442 16l2.712 2.712 15.371-15.5z" />
        <path d="M18.526 28.788l-15.371-15.5L.443 16l15.371 15.5 2.713-2.712z" />
    </svg>
);

export default PrevArrowIcon;